<eds-panel
  class="us-capital-gains-filters"
  theme="dark"
  [edsSpacing]="(isHandheld$ | async) ? 'lg' : 'md'"
>
  <div edsGrid edsPadding edsPaddingBottom="sm">
    <div
      class="container container--wide"
      edsPadding
      [edsPaddingTop]="(isHandheld$ | async) ? 'md' : 'xs'"
    >
      <!-- Title, record details, reset and product type filter -->
      <div edsRow>
        <div edsCol [columnNumbers]="{ s: '4', m: '3', l: '7' }">
          <div
            edsFlexbox
            [flexDirection]="(isHandheld$ | async) ? 'column' : 'row'"
            [alignItems]="(isHandheld$ | async) ? 'flex-start' : 'center'"
            edsPadding
            edsPaddingTop="sm"
          >
            <!-- Title -->
            <eds-title
              size="h2"
              [level]="1"
              [isLight]="true"
              edsSpacing="none"
              edsPadding
              edsPaddingRight="sm"
              >{{
                "products.capgains-estimates-page-heading" | translate
              }}</eds-title
            >
            <div
              edsFlexbox
              alignItems="center"
              [edsSpacing]="(isHandheld$ | async) ? 'sm' : 'none'"
            >
              <!-- Record details - showing X of Y -->
              <p
                edsSpacing="none"
                edsPadding
                edsPaddingRight="sm"
                *ngIf="totalRecords"
              >
                {{ "products.ppss-listing-shows" | translate }}
                <b>{{ filteredRecords }}</b>
                {{ "products.ppss-listing-of" | translate }}
                <b>{{ totalRecords }}</b>
                {{ "products.ppss-listing-items" | translate }}
              </p>

              <!-- Reset filter(s) -->
              <div
                *ngIf="
                  isAnyFilterPresent &&
                  (selectedFilters?.selectedDropdowns?.length ||
                    selectedFilters?.searchedText)
                "
                edsFlexbox
                alignItems="center"
              >
                <span edsPadding edsPaddingRight="sm">|</span>
                <eds-link-item
                  edsFlexbox
                  justifyContent="flex-end"
                  theme="dark"
                  [title]="'products.ppss-filter-reset' | translate"
                  [hasIcon]="true"
                  type="reset"
                  class="text-white"
                  (click)="onFilterReset($event)"
                ></eds-link-item>
              </div>
            </div>
          </div>
        </div>

        <!-- Product type filter -->
        <div
          edsCol
          [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
          *ngIf="isAnyFilterPresent"
        >
          <eds-dropdown
            edsSpacing="none"
            ariaLabel="Dropdown"
            [dropdownId]="productTypeFilter.filterName"
            name="drop-down"
            [multi]="true"
            [items]="productTypeFilter.filterItems"
            [label]="
              'products.capgains-filter-' + productTypeFilter.filterLabel
                | translate
            "
            [titleText]="'products.ppss-filter-select' | translate"
            [selectedText]="'products.ppss-filter-selected' | translate"
            (dropdownChange)="
              onDropdownChange(productTypeFilter.filterName, $event)
            "
            edsPadding
            edsPaddingLeft="none"
            edsFlexItem
            flexGrow="1"
            justifyContent="flex-end"
            #filterDropdowns
          ></eds-dropdown>
        </div>
      </div>

      <!-- Other filter(s) and search by keyword -->
      <div edsRow edsPadding edsPaddingTop="md" *ngIf="isAnyFilterPresent">
        <!-- Other filter(s) -->
        <eds-dropdown
          *ngFor="let filterType of otherFilterTypes"
          edsCol
          [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
          edsSpacing="md"
          ariaLabel="Dropdown"
          [dropdownId]="filterType.filterName"
          name="drop-down"
          [multi]="true"
          [items]="filterType.filterItems"
          [label]="
            'products.capgains-filter-' + filterType.filterLabel | translate
          "
          [titleText]="'products.ppss-filter-select' | translate"
          [selectedText]="'products.ppss-filter-selected' | translate"
          (dropdownChange)="onDropdownChange(filterType.filterName, $event)"
          edsPadding
          edsPaddingLeft="none"
          edsFlexItem
          #filterDropdowns
        ></eds-dropdown>

        <!-- Search by keyword -->
        <eds-search
          edsCol
          fieldId="search__field"
          [columnNumbers]="{ s: '4', m: '3', l: 'auto' }"
          edsSpacing="md"
          [placeholder]="'products.ppss-filter-search-placeholder' | translate"
          edsPadding
          edsPaddingLeft="none"
          flexGrow="1"
          edsPaddingBottom="md"
          (searchTerm)="onSearchInput($event)"
          #filterSearch
        ></eds-search>
      </div>
      <div
        edsFlexbox
        [flexDirection]="(isHandheld$ | async) ? 'column' : 'row'"
      >
        <div
          edsPadding
          edsPaddingRight="xs"
          [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
        >
          <span>{{ "products.hide-funds-no-estimates" | translate }}</span>
          <eds-switch
            [switchId]="'hideFundsSwitch'"
            [disabled]="false"
            [label]="'products.hide-funds-no-estimates' | translate"
            [labelOff]="'products.no' | translate"
            [labelOn]="'products.yes' | translate"
            [state]="hideFundsSwitchState"
            (switchPressed)="setHideFundsToggle($event)"
            ariaLabelledbyStr="hideFundsSwitchLabel"
            labelId="hideFundsSwitchLabel"
            theme="dark"
          ></eds-switch>
        </div>
        <div
          edsPadding
          [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
          [edsPaddingRight]="(isHandheld$ | async) ? 'sm' : 'none'"
          edsPaddingRight="xs"
          *ngIf="showFavoritesOnlySwitch"
        >
          <span>{{ "products.show-favorites-toggle" | translate }}</span>
          <eds-switch
            [switchId]="'favoritesOnlySwitch'"
            [disabled]="false"
            [label]="'products.show-favorites-toggle' | translate"
            [labelOff]="'products.off' | translate"
            [labelOn]="'products.on' | translate"
            [state]="favoritesOnlySwitchState"
            (switchPressed)="setFavoritesOnlyToggle($event)"
            ariaLabelledbyStr="favoritesOnlySwitchLabel"
            labelId="favoritesOnlySwitchLabel"
            theme="dark"
          ></eds-switch>
        </div>
      </div>
    </div>
  </div>
</eds-panel>
